module.exports = __webpack_public_path__ + "static/media/ios_desc.ca59323a.jpg";